(() => {
  function init() {
    document.querySelectorAll('.a19-gallery-widget').forEach(widget => {
      if (widget.dataset.initialized) return;
      widget.dataset.initialized = 'true';
      const root = widget.closest('.a19p');
      const dialog = widget.querySelector('dialog');
      const grid = widget.querySelector('.a19-gallery-grid');
      const view = widget.querySelector('.a19-gallery-view');
      const stage = widget.querySelector('.a19-gallery-stage');
      const image = widget.querySelector('.a19-gallery-image');
      const strip = widget.querySelector('.a19-gallery-strip');
      const counter = widget.querySelector('.a19-gallery-counter');
      const zoom = widget.querySelector('[data-action=zoom]');
      const all = widget.querySelector('[data-action=grid]');
      const items = Array.from(grid.querySelectorAll('[data-index]'));
      let current = 0, opener, savedOverflow, scrollY = 0, drag = null;
      items.forEach(item => {
        const thumb = item.cloneNode(true);
        thumb.querySelector('span').remove();
        thumb.removeAttribute('data-full');
        strip.append(thumb);
      });
      const prev = widget.querySelector('[data-action=prev]');
      const next = widget.querySelector('[data-action=next]');
      const icon = direction => '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="' + (direction < 0 ? 'M15 5 8 12 15 19' : 'M9 5 16 12 9 19') + '"/></svg>';
      prev.innerHTML = icon(-1); next.innerHTML = icon(1);
      const thumbnails = document.createElement('div');
      thumbnails.className = 'a19-gallery-thumbnails'; thumbnails.hidden = true;
      strip.before(thumbnails);
      const back = document.createElement('button'), forward = document.createElement('button');
      [back, forward].forEach((button, i) => {
        button.type = 'button'; button.className = 'a19-gallery-thumb-arrow';
        button.setAttribute('aria-label', (i ? next : prev).getAttribute('aria-label'));
        button.innerHTML = icon(i ? 1 : -1);
      });
      thumbnails.append(back, strip, forward);
      let visibleThumbs = 1;
      function updateThumbButtons() {
        back.disabled = strip.scrollLeft < 2;
        forward.disabled = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 2;
      }
      function layoutThumbnails(reveal = false) {
        if (thumbnails.hidden) return;
        const available = Math.max(90, thumbnails.clientWidth - 136);
        visibleThumbs = Math.min(items.length, Math.max(1, Math.floor((available + 10) / 100)));
        strip.style.width = (visibleThumbs * 100 - 10) + 'px';
        if (reveal) strip.scrollLeft = Math.min(Math.floor(current / visibleThumbs) * visibleThumbs * 100, strip.scrollWidth - strip.clientWidth);
        updateThumbButtons();
      }
      back.addEventListener('click', () => strip.scrollBy({left:-visibleThumbs * 100, behavior:'smooth'}));
      forward.addEventListener('click', () => strip.scrollBy({left:visibleThumbs * 100, behavior:'smooth'}));
      strip.addEventListener('scroll', updateThumbButtons, {passive:true});
      function positionArrows() {
        if (view.hidden || !image.naturalWidth) return;
        const bounds = view.getBoundingClientRect(), rect = image.getBoundingClientRect();
        const css = getComputedStyle(image);
        const pl = parseFloat(css.paddingLeft), pr = parseFloat(css.paddingRight);
        const pt = parseFloat(css.paddingTop), pb = parseFloat(css.paddingBottom);
        const width = rect.width - pl - pr, height = rect.height - pt - pb;
        const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
        const photoWidth = image.naturalWidth * scale, photoHeight = image.naturalHeight * scale;
        const left = rect.left - bounds.left + pl + (width - photoWidth) / 2;
        const midpoint = rect.top - bounds.top + pt + (height - photoHeight) / 2 + photoHeight / 2;
        [prev, next].forEach((button, i) => {
          const x = i ? left + photoWidth + 12 : left - button.offsetWidth - 12;
          button.style.left = Math.max(6, Math.min(bounds.width - button.offsetWidth - 6, x)) + 'px';
          button.style.right = 'auto';
          button.style.top = Math.max(button.offsetHeight / 2, Math.min(bounds.height - button.offsetHeight / 2, midpoint)) + 'px';
        });
      }
      image.addEventListener('load', positionArrows);
      stage.addEventListener('scroll', positionArrows, {passive:true});
      const resizeObserver = new ResizeObserver(() => {layoutThumbnails(true); positionArrows();});
      resizeObserver.observe(view); resizeObserver.observe(thumbnails);
      function resetZoom() {
        stage.classList.remove('is-zoomed', 'is-dragging');
        stage.scrollTo(0, 0);
        zoom.setAttribute('aria-pressed', 'false');
        drag = null;
      }
      function select(index, focusImage = false) {
        current = (index + items.length) % items.length;
        resetZoom();
        grid.hidden = true; view.hidden = false; strip.hidden = false; thumbnails.hidden = false;
        zoom.hidden = false; all.setAttribute('aria-pressed', 'false');
        image.src = items[current].dataset.full;
        image.alt = items[current].querySelector('img').alt || items[current].getAttribute('aria-label');
        counter.textContent = `${widget.dataset.photo} ${current + 1} ${widget.dataset.of} ${items.length}`;
        Array.from(strip.children).forEach((t, i) => t.setAttribute('aria-current', String(i === current)));
        layoutThumbnails(true); requestAnimationFrame(positionArrows);
        if (focusImage) all.focus({preventScroll:true});
      }
      function showGrid() {
        resetZoom(); grid.hidden = false; view.hidden = true; strip.hidden = true; thumbnails.hidden = true; zoom.hidden = true;
        all.setAttribute('aria-pressed', 'true');
        counter.textContent = `${all.textContent} (${items.length})`;
        items[current].focus({preventScroll:true});
      }
      function open(mode, index, target) {
        opener = target; scrollY = window.scrollY;
        savedOverflow = document.documentElement.style.overflow;
        dialog.showModal(); document.documentElement.style.overflow = 'hidden';
        current = index;
        if (mode === 'grid') showGrid(); else select(index, true);
      }
      widget.querySelector('.a19-gallery-open').addEventListener('click', e => open('grid', 0, e.currentTarget));
      const main = root?.querySelector('.a19p-photo');
      main?.addEventListener('click', e => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const index = items.findIndex(item => new URL(item.dataset.full, location.href).href === main.href);
        open('photo', Math.max(0, index), main);
      });
      dialog.addEventListener('click', e => {
        const button = e.target.closest('button');
        if (!button) return;
        if (button.dataset.index !== undefined) { select(Number(button.dataset.index), grid.contains(button)); return; }
        switch (button.dataset.action) {
          case 'close': dialog.close(); break;
          case 'grid': showGrid(); break;
          case 'prev': select(current - 1); break;
          case 'next': select(current + 1); break;
          case 'zoom': {
            const enabled = stage.classList.toggle('is-zoomed');
            zoom.setAttribute('aria-pressed', String(enabled));
            stage.scrollTo((stage.scrollWidth-stage.clientWidth)/2, (stage.scrollHeight-stage.clientHeight)/2);
            requestAnimationFrame(positionArrows);
            break;
          }
        }
      });
      dialog.addEventListener('keydown', e => {
        if (!grid.hidden || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault(); select(current + (e.key === 'ArrowRight' ? 1 : -1));
      });
      dialog.addEventListener('close', () => {
        resetZoom(); document.documentElement.style.overflow = savedOverflow;
        opener?.focus({preventScroll:true}); window.scrollTo({top:scrollY,behavior:'instant'});
      });
      stage.addEventListener('pointerdown', e => {
        if (e.button !== 0) return;
        drag = {id:e.pointerId,x:e.clientX,y:e.clientY,left:stage.scrollLeft,top:stage.scrollTop,zoomed:stage.classList.contains('is-zoomed')};
        stage.setPointerCapture(e.pointerId);
        if(drag.zoomed) stage.classList.add('is-dragging');
      });
      stage.addEventListener('pointermove', e => {
        if (!drag || drag.id !== e.pointerId || !drag.zoomed) return;
        stage.scrollLeft = drag.left + drag.x - e.clientX;
        stage.scrollTop = drag.top + drag.y - e.clientY;
      });
      stage.addEventListener('pointerup', e => {
        if (!drag || drag.id !== e.pointerId) return;
        const dx=e.clientX-drag.x, dy=e.clientY-drag.y;
        if(!drag.zoomed && Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.3) select(current+(dx<0?1:-1));
        drag=null; stage.classList.remove('is-dragging');
      });
      stage.addEventListener('pointercancel', () => {drag=null;stage.classList.remove('is-dragging');});
      if(items.length < 2) dialog.querySelectorAll('[data-action=prev],[data-action=next]').forEach(b=>b.hidden=true);
    });
  }
  init(); document.addEventListener('shopify:section:load',init);
})();
